export const HeaderTemplate = {
    path: '/header_templates',
    name: 'header_templates',
    component: () => import('@/views/Edms/Template/HeaderTemplatePage.vue'),
    children: [

        {
            path: '/header_templates/add',
            name: 'header_templates.add',
            component: () => import('@/views/Edms/Template/Form/HeaderTemplateForm.vue'),
            props: { addAction: true }
        },
        {
            path: '/header_templates/edit/:id',
            name: 'header_templates.edit',
            component: () => import('@/views/Edms/Template/Form/HeaderTemplateForm.vue'),
            props: { updateAction: true }
        },
        {
            path: '/header_templates/delete/:id',
            name: 'header_templates.delete',
            component: () => import('@/views/Edms/Template/Form/HeaderTemplateForm.vue'),
            props: { deleteAction: true }
        },
        {
            path: '/header_templates/view/:id',
            name: 'header_templates.view',
            component: () => import('@/views/Edms/Template/Form/HeaderTemplateForm.vue'),
            props: { viewAction: true }
        },
        {
            path: '/header_templates/archive/:id',
            name: 'header_templates.archive',
            component: () => import('@/views/Edms/Template/Form/HeaderTemplateForm.vue'),
            props: { archiveAction: true }
        },
        {
            path: '/header_templates/unarchive/:id',
            name: 'header_templates.unarchive',
            component: () => import('@/views/Edms/Template/Form/HeaderTemplateForm.vue'),
            props: { unarchiveAction: true }
        },
    ],
}
